export default [
    {
        path: '/auth/login',
        name: 'auth-login',
        component: () => import('@/views/auth/Login.vue'),
        meta: {
            layout: 'full',
            pageTitle: 'User Login',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/auth/forgot-password',
        name: 'auth-forgot-password',
        component: () => import('@/views/auth/ForgotPassword.vue'),
        meta: {
            layout: 'full',
            pageTitle: 'Forgot Password',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
]
